import Vue from 'vue'
import Router from 'vue-router'
import AuthRequired from '@/utils/AuthRequired'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: () => import('./views/app'),
    redirect: '/app',
    beforeEnter: AuthRequired,
    children: [
      {
        path: 'app',
        component: () => import('./views/app/dashboards'),
        redirect: '/app/dashboard',
        children: [
          { name: 'default',path: 'dashboard', component: () => import('./views/app/dashboards/Default') },
          { name: 'assistants',path: 'assistants', component: () => import('./views/app/pages/Assistants.vue') },
          { name: 'patients',path: 'patients', component: () => import('./views/app/pages/Patients.vue') },
          { name: 'patient',path: 'patients/:id', component: () => import('./views/app/pages/PatientDetails.vue') },
          { name: 'rdv',path: 'operations/:id', component: () => import('./views/app/pages/OperationDetails') },
          { name: 'rdvs',path: 'operations', component: () => import('./views/app/pages/Rdvs.vue') },
          { name: 'invoices',path: 'invoices', component: () => import('./views/app/pages/Certificates.vue') },
          { name: 'charts',path: 'charts', component: () => import('./views/app/pages/Statistiques.vue') },
          { name: 'account',path: 'account', component: () => import('./views/app/pages/Account.vue') },
        ]
      }
    ]
  },
  { path: '/error', component: () => import('./views/Error') },
  {
    path: '/user',
    component: () => import('./views/user'),
    redirect: '/user/login',
    children: [
      {name:"login", path: 'login', component: () => import('./views/user/Login') },
      { path: 'forgot-password', component: () => import('./views/user/ForgotPassword') }
    ]
  },
  { path: '*', component: () => import('./views/Error') }
]

const router = new Router({
  base: '',
  routes:routes,
  mode: 'history'
})

export default router
